import PDF from './PDF.svg';
import JPG from './JPEG.svg';
import PNG from './PNG.svg';

const types = { PDF, PNG, JPG };
export default types;
